import { EditorEvents } from '@tiptap/core'
import { tableOptionsMenuClassName } from '../components/ControlBar/TableControlButton'

/**
 * A common blur handler for components within the editor that need to respond
 * when the editor loses focus. It ignores events related to content-adjacent
 * targets, except for the "Close" button.
 *
 * @example
 * const handler = editorBlurHandler(() => do something))
 * editor.on('blur', handler)
 */
const editorBlurHandler =
  (callback?: (editorEvent: EditorEvents['blur']) => void) =>
  (editorEvent: EditorEvents['blur']): void => {
    const { event, editor } = editorEvent
    const editorContainer =
      (editor.view.dom.isConnected &&
        editor.view.dom.parentElement?.parentElement) ||
      null
    const target = event.relatedTarget

    if (
      target instanceof HTMLElement &&
      // Don't consider editor unfocused if a control bar button was clicked
      (editorContainer?.contains(target) ||
        target.classList.contains(tableOptionsMenuClassName))
    ) {
      return
    }

    callback?.(editorEvent)
  }

export default editorBlurHandler
